import React, { FC } from 'react';
import styled, { css } from 'styled-components/macro';

import media from 'helpers/media';
import { ColorVariants } from 'theme';

import Icon from 'components/Icon';

const Allignment = {
    left: css`
        text-align: left;
    `,
    center: css`
        justify-content: center;
        text-align: center;
    `,
    right: css`
        justify-content: flex-end;
        text-align: right;
    `,
};

const Wrapper = styled.div<{
    color: ColorVariants;
    background: ColorVariants;
    align: 'center' | 'left' | 'right';
    plain: boolean;
    verticalCenter?: boolean;
}>`
    position: relative;
    padding: ${({ theme }) => theme.space.base};
    display: flex;

    ${({ theme, color }) => `color: ${theme.colors[color]};`}
    ${({ theme, background }) =>
        `background-color: ${theme.colors[background]};`}
    ${({ align }) => Allignment[align]};

    &:not(:last-child) {
        margin-bottom: ${({ theme }) => theme.space.large};
    }

    ${({ plain }) =>
        plain &&
        css`
            padding: 0;
            background-color: transparent;
        `}

    ${({ verticalCenter }) =>
        verticalCenter &&
        css`
            align-items: center;
        `}

    ${({ theme }) => media.mobile`
        &:not(:last-child) {
            margin-bottom: ${theme.space.base};
        }
    `};
`;

const StyledIcon = styled((props) => <Icon {...props} />)<{
    $iconColor?: ColorVariants;
}>`
    margin-right: 16px;
    line-height: 1.4rem;

    ${({ theme, $iconColor }) =>
        $iconColor &&
        css`
            color: ${theme.colors[$iconColor]};
        `};
`;

export interface AlertProps {
    /** Alignment of the buttons */
    align: 'left' | 'center' | 'right';

    /** Text color */
    color?: ColorVariants;

    /** Use the plain style */
    plain?: boolean;

    /** Optional icon */
    icon?: string;

    /** Background color */
    background?: ColorVariants;

    verticalCenter?: boolean;

    iconColor?: ColorVariants;
}

const Alert: FC<AlertProps & React.HTMLAttributes<HTMLDivElement>> = ({
    align = 'left',
    plain = false,
    color = 'white',
    icon,
    background = 'ringFinger',
    children,
    verticalCenter,
    iconColor,
    ...props
}) => {
    return (
        <Wrapper
            role="alert"
            plain={plain}
            align={align}
            background={background}
            color={color}
            verticalCenter={verticalCenter}
            {...props}
        >
            {icon && (
                <StyledIcon $iconColor={iconColor} name={icon} size={16} />
            )}
            <div className="Alert_msg">{children}</div>
        </Wrapper>
    );
};

export default Alert;
